(() => {
  const heroes = document.querySelectorAll('[data-sp-hero]');

  heroes.forEach((hero) => {
    const slides = [...hero.querySelectorAll('.sp-home-hero__slide')];
    const dots = [...hero.querySelectorAll('.sp-home-hero__dot')];
    const prev = hero.querySelector('[data-sp-prev]');
    const next = hero.querySelector('[data-sp-next]');
    const autoplay = hero.dataset.autoplay === 'true';
    const speed = Number(hero.dataset.speed || 5000);
    let index = 0;
    let timer;

    const setSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };

    const restart = () => {
      window.clearInterval(timer);
      if (autoplay && slides.length > 1) timer = window.setInterval(() => setSlide(index + 1), speed);
    };

    prev?.addEventListener('click', () => {
      setSlide(index - 1);
      restart();
    });
    next?.addEventListener('click', () => {
      setSlide(index + 1);
      restart();
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        setSlide(dotIndex);
        restart();
      });
    });

    restart();
  });
})();
